module.exports = __webpack_public_path__ + "img/ma-bottom.0c240168.png";